// extracted by mini-css-extract-plugin
export default {"contentBlock":"OcMhXjnrnEPjTqLRm2E8","inbodyPin":"wDH60EU2KWlTJSvxAZ4S"};